module.exports = __webpack_public_path__ + "img/prizePhoneHint.37a6a8ba.png";